export default __webpack_public_path__ + "0a672585ecec3ae76f9112a33db46540.png";